skrilla.directive('searchPromotions', function () {
    return {
        templateUrl: 'directives/searchPromotions/searchPromotions.html',
        scope: {
            onClick: "=",
            active: "=",
            purposes: "=",
            key: "="
        },
        controller: function ($scope, searchService, cacheService, paginationService, queryService, currencyService, promotionService) {
            $scope.reset = function () {
                const purposes = $scope.purposes || promotionService.getPurposes()
                $scope.defaultPurposes = {};
                Object.keys(purposes).forEach(it => $scope.defaultPurposes[it] = true )
                $scope.query = {
                    purposes: purposes,
                    currencies: currencyService.getCurrencyMap(),
                    limit: 20,
                    active: $scope.active
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getPromotions, $scope.key);
            }

            var getPromotions = function () {

                //Do this so we dont get referrals in the response
                const query = {...$scope.query};
                if (!Object.values(query.purposes).find(it => it)) {
                    query.purposes = $scope.defaultPurposes;
                }
                return searchService.get("promotions/definitions" + queryService.getQueryString(query, $scope.key)).then(function (response) {
                    $scope.promotions = response.data.result;
                    cacheService.registerObject($scope.key + "promotionsTable", $scope.promotions);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.search()
        }
    };
});
